/**
 * Whether an error or response is the "Access Denied" an expired session
 * returns, which is expected and should not reach Bugsnag.
 * @param {object} [opts={}]
 * @param {Error|string|object} [opts.error] Thrown error, rejected string, or
 * resolved `{ msg }` payload.
 * @returns {boolean}
 */
const isAccessDeniedError = (opts = {}) => {
  const { error } = opts;

  if (!error) {
    return false;
  }

  if (typeof error === 'string') {
    return error.includes('Access Denied');
  }

  const errorMessage = error.message || error.msg || error.err?.message;

  return !!errorMessage && errorMessage.includes('Access Denied');
};

export default isAccessDeniedError;
